import { Action, Reducer } from 'redux';
import { CLAIMS_LOADING, CLAIMS_LOADED, CLAIM_LOADED, CLAIM_LOADING, PRICE_OFFER_SAVED, PRICE_OFFER_SAVING, SENT_PRICE_OFFERS_LOADED, SENT_PRICE_OFFERS_LOADING, NETWORKS_LOADED, PURCHASE_ORDERS_LOADED, PURCHASE_ORDERS_LOADING, SUBSCRIPTION_HISTORY_LOADED, SUBSCRIPTION_HISTORY_LOADING, CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADED, CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADING, SELLER_SENT_PRICE_OFFERS_LOADED, SELLER_SENT_PRICE_OFFERS_LOADING, STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADED, STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADING, TERMS_AND_CONDITIONS_LOADED, TERMS_AND_CONDITIONS_LOADING } from "./SellerClaims.action";
import { initialState } from './SellerClaims.state';

export const SellerClaimsReducer: Reducer<any, Action> = (state = initialState, action: any) => {
    let newState = state;

    switch (action.type) {
        case CLAIMS_LOADING:
            newState = { ...newState, loading: true, sellerClaimsLoading: true, totalClaimsCount: 0 };
            break;
        case CLAIMS_LOADED:
            newState = { ...newState, loading: false, sellerClaimsLoading: false, claims: action.payload.data, totalClaimsCount: action.payload.total };
            break;
        case CLAIM_LOADING:
            newState = { ...newState, claimLoading: true, claimInfo: null };
            break;
        case CLAIM_LOADED:
            newState = { ...newState, claimLoading: false, claimInfo: action.payload };
            break;
        case PRICE_OFFER_SAVING:
            newState = { ...newState, priceOfferSaving: true };
            break;
        case PRICE_OFFER_SAVED:
            newState = { ...newState, priceOfferSaving: false, savePriceOfferResult: action.payload };
            break;
        case SENT_PRICE_OFFERS_LOADING:
            newState = { ...newState, sentPriceOfferLoading: true, sentPriceOffers: [], totalSentOffers: 0 };
            break;
        case SENT_PRICE_OFFERS_LOADED:
            newState = { ...newState, sentPriceOfferLoading: false, sentPriceOffers: action.payload?.data, totalSentOffers: action.payload?.total };
            break;
        case NETWORKS_LOADED:
            newState = { ...newState, networksList: action.payload };
            break;
        case PURCHASE_ORDERS_LOADING:
            newState = { ...newState, purchaseOrdersLoading: true, purchaseOrders: [], totalPurchaseOrders: 0 };
            break;
        case PURCHASE_ORDERS_LOADED:
            newState = { ...newState, purchaseOrdersLoading: false, purchaseOrders: action.payload?.data, totalPurchaseOrders: action.payload?.total };
            break;
        case SUBSCRIPTION_HISTORY_LOADING:
            newState = { ...newState, subscriptionsHistoryLoading: true, subscriptionHistory: [], totalSubscriptions: 0 };
            break;
        case SUBSCRIPTION_HISTORY_LOADED:
            newState = { ...newState, subscriptionsHistoryLoading: false, subscriptionHistory: action.payload, totalSubscriptions: action.payload?.length };
            break;
        case STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADING:
            newState = { ...newState, reportResultLoading: true,  reportResult: null};
            break;
        case STATS_OF_AUCTIONS_WITH_NO_SELLER_PARTICIPATION_LOADED:
            newState = { ...newState, reportResultLoading: false, reportResult: action.payload };
            break;
        case SELLER_SENT_PRICE_OFFERS_LOADING:
            newState = { ...newState, reportResultLoading: true, reportResult: null };
            break;
        case SELLER_SENT_PRICE_OFFERS_LOADED:
            newState = { ...newState, reportResultLoading: false, reportResult: action.payload };
            break;
        case CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADING:
            newState = { ...newState, reportResultLoading: true, reportResult: null };
            break;
        case CLAIM_LEAST_PRICE_OFFERS_SENT_BY_SELLER_LOADED:
            newState = { ...newState, reportResultLoading: false, reportResult: action.payload };
            break;
        case TERMS_AND_CONDITIONS_LOADING:
            newState = { ...newState, termsAndConditionsLoading: true };
            break;
        case TERMS_AND_CONDITIONS_LOADED:
            newState = { ...newState, termsAndConditionsLoading: false, termsAndConditions: action.payload };
            break;
    }
    return newState;
};
